import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    formTypes: [],
    loaded: false
  }
};
const FormTypesSlice = createSlice({
  name: "formTypes",
  initialState,
  reducers: {
    loadFTs: (state, action) => {
      state.value = {
        formTypes: action.payload,
        loaded: true
      };
    }
  }
});
export const { loadFTs } = FormTypesSlice.actions;
export default FormTypesSlice.reducer;
